import graphql from "babel-plugin-relay/macro";

import { useMutationWithError } from "../../../../../../../utils/hooks/useMutationWithError";
import { useCreatePhoneVerificationNotificationsMutation } from "./__generated__/useCreatePhoneVerificationNotificationsMutation.graphql";

export const useCreatePhoneVerificationNotifications = () => {
  const [createVerification, isCreating] =
    useMutationWithError<useCreatePhoneVerificationNotificationsMutation>(
      useCreatePhoneVerificationNotificationsMutationString
    );

  const createPhoneVerification = (
    phoneNumber: string,
    onCompleteHandler: () => void
  ) => {
    createVerification({
      variables: { input: { phoneNumber } },
      onCompleted: (res) => {
        if (res.responsePayload?.success) {
          onCompleteHandler();
        }
      },
    });
  };
  return [createPhoneVerification, isCreating] as const;
};

export const useCreatePhoneVerificationNotificationsMutationString = graphql`
  mutation useCreatePhoneVerificationNotificationsMutation(
    $input: CreatePhoneVerificationInput!
  ) {
    responsePayload: createPhoneVerification(input: $input) {
      success
      errors {
        field
        code
        message
      }
    }
  }
`;
